export default {
  '0001': 'Dallas - Downtown (DT)',
  '0002': 'Dallas - Northpark (NP)',
  '0003': 'Fort Worth (FW)',
  '0004': 'Houston Galleria (HO)',
  '0005': 'Bal Harbour (BH)',
  '0006': 'Atlanta (AT)',
  '0007': 'St. Louis (SL)',
  '0008': 'Washington (WA)',
  '0009': 'Northbrook (NB)',
  '0010': 'Beverly Hills (LA)',
  '0011': 'Fashion Island (FI)',
  '0012': 'San Francisco (SF)',
  '0013': 'Willow Bend (PWB)',
  '0014': 'Weschester (WC)',
  '0015': 'Las Vegas (LV)',
  '0016': 'San Diego (SD)',
  '0017': 'Oakbrook (OB)',
  '0018': 'Ft. Lauderdale (FL)',
  '0019': 'Michigan Ave (MA)',
  '0020': 'Boston (BN)',
  '0023': 'Tysons Galleria (TY)',
  '0024': 'Palo Alto (PA)',
  '0025': 'Short Hills (SH)',
  '0027': 'Denver (DN)',
  '026A': 'Minneapolis',
  '0028': 'Paramus (PR)',
  '0029': 'Scottsdale (SC)',
  '0030': 'King of Prussia (KP)',
  '0031': 'Ala Moana (AM)',
  '0032': 'Palm Beach (PB)',
  '0033': 'Troy (TR)',
  '0034': 'Coral Gables (CG)',
  '0035': 'Tampa Bay (TB)',
  '0036': 'Orlando (OR)',
  '0037': 'San Antonio (SA)',
  '0038': 'Boca Raton (BR)',
  '0042': 'Katy Mills',
  '0043': 'San Diego',
  '0044': 'Miami Dolphin Mall',
  '0048': 'Colorado Mills',
  '0050': 'Online',
  '0051': 'Grapevine Mills',
  '0052': 'Plano',
  '0053': 'Dallas - Horchow Finale: Mockingbird Lane',
  '0054': 'Woodbury Common Premium Outlets',
  '0055': 'Fashion Outlets of Las Vegas',
  '0056': 'Arizona Mills',
  '0057': 'Great Lakes Crossing',
  '0058': 'The Mills at Jersey Gardens',
  '0059': 'Sugarloaf Mills',
  '0063': "BG WOMEN'S STORE",
  '0064': "BG MEN's STORE",
  '0070': 'Austin Brodie Oaks Shopping Center',
  '0071': 'Philadelphia Mills',
  '0072': 'Sawgrass Mills',
  '0079': 'Lockerstock',
  '0080': 'Las Colinas',
  '0088': 'Las Colinas',
  '0089': 'Pinnacle',
  '0101': 'Austin (AN)',
  '0102': 'Charlotte (CH)',
  '0103': 'Natick (NA)',
  '0105': 'Topanga (TP)',
  '0106': 'Bellevue (BL)',
  '0110': 'Walnut Creek (WK)',
  '0111': 'Roosevelt Field (RF)',
  '0112': 'Hudson Yards (HY)',
  '0201': 'San Marcos Premium Outlets',
  '0202': 'Arundel Mills',
  '0203': 'Milpitas Great Mall',
  '0204': 'Orlando Premium Outlets-International Drive',
  '0206': 'Allen Premium Outlets',
  '0207': 'Miromar Outlets',
  '0208': 'Philadelphia Premium Outlets',
  '0209': 'Gurnee Mills',
  '0210': 'Tanger Outlets at the Arches',
  '0211': 'Inwood Village',
  '0212': 'Camarillo Premium Outlets',
  '0213': 'Potomac Mills',
  '0214': 'The Outlets at Orange',
  '0216': 'Livermore Premium Outlets',
  '0217': 'The Outlets at Bergen Town Center',
  '0218': 'Congressional Plaza',
  '0219': 'Preston Shepard Place',
  '0220': 'Desert Hills Premium Outlets',
  '0221': 'Ontario Mills',
  '0222': 'Post Oak Shopping Center',
  '0224': 'Fashion Outlets of Chicago',
  '0225': 'Riverwalk',
  '0226': 'Legacy Place',
  '0228': 'Ohio Street',
  '0227': 'Market Street - Now Open',
  '0229': 'Lenox Marketplace',
  '0230': 'Brooklyn',
  '0231': 'Vegas North',
};
